import { useMemo } from "react";
import bakedPayload from "@/data/phoneResponseLoop.json";
import { PhoneBoard } from "./PhoneBoard";

// The phone board at /phone — the call loop's route, mounted beside the
// other portfolio surfaces. Reads the redacted committed payload (the same
// file the loop's build step verifies); the transcripts never leave Kit's
// machine, so there is no transcript fetch here.
//
// Live backend rows arrive later on the same pattern as other boards; the
// committed payload is the fallback so the page never renders empty.

export default function PhonePage({ brandScope }) {
  const payload = useMemo(() => {
    if (!brandScope) return bakedPayload;
    // brand scope: slice the stream + lines to that brand's rows
    const lines = (bakedPayload.lines || []).filter(
      (l) => l.brand === brandScope);
    const keep = new Set(lines.map((l) => l.line));
    const stream = (bakedPayload.stream || []).filter(
      (r) => keep.has(r.line) || r.brand === brandScope);
    const tiles = { ...bakedPayload.tiles, calls: stream.length,
                    lines: lines.length };
    const handled = stream.filter((r) => r.handled === "handled").length;
    const missed = stream.filter((r) => r.handled === "missed").length;
    const unattended = stream.filter((r) => r.handled === "unattended").length;
    const outgoing = stream.filter((r) => r.handled === "outgoing").length;
    return { ...bakedPayload, lines, stream, tiles: { ...tiles, handled, missed,
             unattended, outgoing, transcripts: stream.filter((r) => r.has_transcript).length } };
  }, [brandScope]);
  return (
    <div data-testid="phone-page" className="w-full font-inter text-os-ink">
      <div className="mx-auto flex max-w-[100rem] flex-col gap-5 px-10 py-6">
        <header className="flex items-baseline justify-between gap-4">
          <div>
            <h1 className="text-[1.5rem] font-semibold tracking-[-0.01em]">
              Phone
            </h1>
            <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.08em] text-os-ink-2">
              {payload.source} · {payload.privacy}
            </p>
          </div>
          <span className="font-mono text-[10px] uppercase tracking-[0.08em] text-os-ink-2">
            current as of {payload.as_of?.slice(0, 16).replace("T", " ")}
          </span>
        </header>
        <PhoneBoard payload={payload} />
      </div>
    </div>
  );
}